module.exports = __webpack_public_path__ + "static/media/box.c87ed960.svg";